import type { UserDto } from '@timato/shared';

/** Up to two letters from a name, or the email when there is none. */
export const initialsOf = (u: Pick<UserDto, 'name' | 'email'>) =>
  (u.name ?? u.email).split(/[\s@.]+/).filter(Boolean).slice(0, 2).map((s) => s[0]!.toUpperCase()).join('') || '\u00b7';
